import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaHome, FaCalendarAlt, FaPlus, FaCommentDots, FaUserMd } from 'react-icons/fa';
import { useRolePath } from '../context/AppContext';

const BottomNav = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const rp        = useRolePath();

  const navItems = [
    { label: 'Home',         icon: FaHome,        path: rp('/') },
    { label: 'Appointments', icon: FaCalendarAlt,  path: rp('/appointments') },
    { label: 'New',          icon: FaPlus,         path: rp('/new-appointment'), isAction: true },
    { label: 'Chat',         icon: FaCommentDots,  path: rp('/messages') },
    { label: 'Profile',      icon: FaUserMd,       path: rp('/profile') },
  ];

  return (
    <>
      <style>{`
        .bottom-nav {
          position: fixed; bottom: 0; left: 0; right: 0;
          height: var(--bottom-nav-height); background: white;
          display: flex; align-items: center; justify-content: space-around;
          z-index: 500; box-shadow: 0 -2px 16px rgba(0,0,0,0.08);
          border-top: 1px solid var(--border); padding: 0 8px;
        }
        .bottom-nav-item {
          display: flex; flex-direction: column; align-items: center;
          gap: 3px; padding: 6px 12px; cursor: pointer;
          border-radius: 12px; transition: all 0.18s ease;
          min-width: 55px; position: relative;
        }
        .bottom-nav-item:hover { background: var(--primary-bg); }
        .bottom-nav-icon { font-size: 20px; color: var(--text-light); transition: color 0.18s; }
        .bottom-nav-item.active .bottom-nav-icon { color: var(--primary); }
        .bottom-nav-label { font-size: 10px; font-weight: 600; color: var(--text-light); transition: color 0.18s; }
        .bottom-nav-item.active .bottom-nav-label { color: var(--primary); }
        .bottom-nav-action {
          background: linear-gradient(135deg, #E8500A, #FF6B2C);
          width: 50px; height: 50px; border-radius: 16px;
          display: flex; align-items: center; justify-content: center;
          color: white !important; font-size: 22px;
          box-shadow: 0 4px 14px rgba(232,80,10,0.40);
          transition: transform 0.18s, box-shadow 0.18s; margin-bottom: 4px;
        }
        .bottom-nav-item:hover .bottom-nav-action {
          transform: scale(1.08) translateY(-2px);
          box-shadow: 0 6px 20px rgba(232,80,10,0.50);
        }
        .bottom-nav-active-dot {
          position: absolute; bottom: 2px; width: 5px; height: 5px;
          background: var(--primary); border-radius: 50%;
        }
      `}</style>
      <nav className="bottom-nav">
        {navItems.map(item => {
          const isActive = location.pathname === item.path;
          return (
            <div
              key={item.path}
              className={`bottom-nav-item ${isActive ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              {item.isAction ? (
                <>
                  <div className="bottom-nav-action"><item.icon /></div>
                  <span className="bottom-nav-label" style={{ color: 'var(--primary)' }}>{item.label}</span>
                </>
              ) : (
                <>
                  <item.icon className="bottom-nav-icon" />
                  <span className="bottom-nav-label">{item.label}</span>
                  {isActive && <div className="bottom-nav-active-dot" />}
                </>
              )}
            </div>
          );
        })}
      </nav>
    </>
  );
};

export default BottomNav;
